import { useEffect, useState } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { CommandBar } from '@fluentui/react';
import { api } from '../services/api';
import styles from './InstanceEmbed.module.css';

export default function InstanceTerminal() {
  const { id, sessionName } = useParams<{ id: string; sessionName?: string }>();
  const navigate = useNavigate();
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id || !sessionName) return;
    let cancelled = false;

    api.getProxyToken(id).then(({ token }) => {
      if (cancelled) return;
      const url = `https://proxy.agentbox.networg.com/instances/${id}/terminal/sessions/${sessionName}/?proxy_token=${encodeURIComponent(token)}`;
      setIframeSrc(url);
    }).catch(err => {
      if (!cancelled) setError(err.message);
    });

    return () => { cancelled = true; };
  }, [id, sessionName]);

  if (!sessionName) return <Navigate to={`/instances/${id}`} replace />;

  const commandBarItems = [
    { key: 'back', iconOnly: true, iconProps: { iconName: 'Back' }, onClick: () => { navigate(`/instances/${id}`); }, ariaLabel: 'Back' },
    { key: 'title', text: `Terminal — ${sessionName}`, disabled: true },
  ];

  return (
    <div className={styles.container}>
      <CommandBar items={commandBarItems} styles={{ root: { borderBottom: '1px solid var(--ab-border)', background: 'var(--ab-bg-command-bar)', padding: '0 8px', flexShrink: 0 } }} />
      {error ? (
        <p style={{ padding: 20 }}>Failed to authenticate: {error}</p>
      ) : !iframeSrc ? (
        <p style={{ padding: 20 }}>Authenticating…</p>
      ) : (
        <iframe src={iframeSrc} className={styles.frame} title={`Terminal — ${sessionName}`} />
      )}
    </div>
  );
}
